import { CommonModule } from '@angular/common';
import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'web-image-size-limit-modal',
    template: `<div class="alert-box">
        <div class="modal-header">
            <button type="button" class="close" (click)="onCancel()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
                {{ 'image_size_limit_title' | translate }}
            </h4>
        </div>
        <div class="modal-body">
            <p class="text-warning">
                <b>{{ imageName }}</b> {{ 'image_size_limit_text' | translate }}
            </p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" (click)="onCancel()">
                {{ 'close' | translate }}
            </button>
        </div>
    </div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TranslateModule],
})
export class ImageSizeLimitModalComponent implements OnInit {
    private readonly bsModalRef: BsModalRef = inject(BsModalRef);
    @Input() public imageName: string;

    public onClose: Subject<boolean>;

    public ngOnInit(): void {
        this.onClose = new Subject();
    }

    public onConfirm(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }

    public onCancel(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }
}
